import { Col, Row, Form, Input, Button } from "antd";
import { Header } from "../../../components/SecurityCheck/Header";
import { useValidateOnBlur } from "../../../lib/hooks/validateOnBlur";
import { useCallback, useState, FocusEvent } from "react";
import {
  useToggleCapsLock,
  CapsLockHint,
} from "../../../components/CapsLockHint";
import { PasswordInput } from "../../../components/PasswordInput";
import { useUpdate } from "./hooks/useUpdate";
import { useCredsRules } from "../../../lib/hooks/useCredsRules";

type SecondStepProps = {
  onBackClicked: () => void;
};

export const SecondStep = ({ onBackClicked }: SecondStepProps) => {
  const [form] = Form.useForm();

  const [isCapsLockOnOld, onPasswordTypeOld] = useToggleCapsLock(false);

  const [isPasswordValid, setIsPasswordValid] = useState<boolean>(false);

  const [validateOnBlur] = useValidateOnBlur(form);

  const { isFormDisabled, update } = useUpdate(isPasswordValid);

  const { passwordRules } = useCredsRules();

  const onBlur = useCallback(
    (e: FocusEvent<HTMLInputElement, Element>) =>
      validateOnBlur(e, "oldPassword"),
    [validateOnBlur],
  );

  return (
    <Row className="mt-16 justify-center">
      <Col className="security-check-content mb-8">
        <Header header="Update your password" onBackClicked={onBackClicked} />

        <Row className="mt-10 d-flex justify-center">
          <Col className="form-content">
            <Form
              form={form}
              layout="vertical"
              autoComplete="off"
              requiredMark={false}
              disabled={isFormDisabled}
              className="form__container"
              onFinish={update}
            >
              <div className="position-relative">
                <Form.Item
                  name="oldPassword"
                  label="Old Password"
                  className="mb-5"
                  rules={passwordRules}
                >
                  <Input.Password
                    size="large"
                    onBlur={onBlur}
                    onKeyUp={onPasswordTypeOld}
                  />
                </Form.Item>

                {isCapsLockOnOld && <CapsLockHint />}
              </div>

              <div className="position-relative">
                <PasswordInput
                  label="New Password"
                  form={form}
                  setIsPasswordValid={setIsPasswordValid}
                />
              </div>

              <Form.Item className="mt-3 mb-12">
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  htmlType="submit"
                  disabled={!isPasswordValid || isFormDisabled}
                  block
                  loading={isFormDisabled}
                >
                  Update password
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
